<div class="progress md-progress" style="height: 20px">
    <div class="progress-bar" role="progressbar" style="width: 100%; height: 20px" aria-valuenow="vm.valueNow" aria-valuemin="0" aria-valuemax="100">{{vm.valueNow}}%</div>
</div>
